import { Controller } from "react-hook-form";
import { CFormCheck, CFormInput, CFormTextarea } from "@coreui/react";
import InfiniteScrollSelect from "../../components/ui/InfiniteScrollSelect";
import { useEffect, useState } from "react";
import { PROMO_RESTRICTION_TYPESV2 } from "../../rules/promo";
import FileUploaderV2 from "../../components/ui/FileUploaderV2";

export default function CreateRewardForm({
  control,
  setValue,
  watch,
  data,
  mode,
}: any) {
  const promoScope = watch("promoScope");
  const type = watch("type");

  useEffect(() => {
    if (promoScope !== "EVENT") {
      setValue("event", null);
    }
    if (promoScope !== "SPECIALS") {
      setValue("offer", null);
    }
    if (promoScope !== "PLACE") {
      setValue("place", null);
    }

    if (promoScope !== "GLOBAL") {
      setValue("restrictionType", "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [promoScope]);

  useEffect(() => {
    if (mode === "create" && type === "BOOKING") {
      setValue("promoScope", "GLOBAL");
      setValue("restrictionType", "NONE");
    }
  }, [type, mode, setValue]);

  useEffect(() => {
    if (mode === "edit" && data?.picture) {
      setValue("picture", data.picture, {
        shouldValidate: true,
        shouldDirty: false,
      });
    }
  }, [mode, data?.picture, setValue]);

  const [hasNewImage, setHasNewImage] = useState(false);

  return (
    <div className="row form">
      {/* TITLE */}
      <div className="col-md-6 mt-4">
        <Controller
          name="title"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <CFormInput
                type="text"
                {...field}
                placeholder="Title"
                label={
                  <>
                    Titre <span className="text-danger">*</span>
                  </>
                }
              />
              <ErrorMessage error={fieldState.error?.message} />
            </>
          )}
        />
      </div>

      {/* POINTS */}
      <div className="col-md-6 mt-4">
        <Controller
          name="pointsRequired"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <CFormInput
                type="number"
                {...field}
                placeholder="Points"
                label={
                  <>
                    Points Requis <span className="text-danger">*</span>
                  </>
                }
              />
              <ErrorMessage error={fieldState.error?.message} />
            </>
          )}
        />
      </div>

      {/* DESCRIPTION */}
      <div className="col-md-6 mt-4">
        <Controller
          name="description"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <CFormTextarea
                {...field}
                id="description"
                name="description"
                rows={4}
                placeholder="Décrivez les conditions de la récompense..."
                label="Description"
              />

              <ErrorMessage error={fieldState.error?.message} />
            </>
          )}
        />
      </div>

      {/* DISCOUNT */}
      <div className="col-md-6 mt-4">
        <Controller
          name="discount"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <CFormInput
                type="number"
                {...field}
                placeholder="Discount %"
                label={
                  <>
                    Discount <span className="text-danger">*</span>
                  </>
                }
              />
              <ErrorMessage error={fieldState.error?.message} />
            </>
          )}
        />
      </div>

      {/* MAX USES */}
      <div className="col-md-6 mt-4">
        <Controller
          name="maxUses"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <CFormInput
                type="number"
                {...field}
                placeholder="Max Uses"
                label={
                  <>
                    Max Uses <span className="text-danger">*</span>
                  </>
                }
              />
              <ErrorMessage error={fieldState.error?.message} />
            </>
          )}
        />
      </div>

      {/* TYPE */}
      <div className="col-md-6 mt-4">
        <Controller
          name="type"
          control={control}
          defaultValue="OFFER"
          render={({ field, fieldState }) => (
            <div className="d-flex flex-column gap-1">
              <label>
                Type de Bonus <span className="text-danger">*</span>
              </label>
              <select {...field} className="form-select">
                <option value="">Selectionner un type</option>
                <option value="BOOKING">Booking</option>
                <option value="RIDE">Ride</option>
              </select>
              <ErrorMessage error={fieldState.error?.message} />
            </div>
          )}
        />
      </div>

      {/* FEATURED */}
      <div className="col-md-6 mt-4">
        <Controller
          name="isFeatured"
          control={control}
          render={({ field, fieldState }) => (
            <div className="d-flex flex-column gap-1">
              <label>
                Featured <span className="text-danger">*</span>
              </label>
              <select {...field} className="form-select">
                <option value="">Selectionner un option</option>
                <option value="true">Vraix</option>
                <option value="false">Faux</option>
              </select>
              <ErrorMessage error={fieldState.error?.message} />
            </div>
          )}
        />
      </div>

      {/* Expired at */}

      <div className="col-md-6 mt-4">
        <Controller
          name="expiresAt"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <CFormInput
                type="date"
                {...field}
                placeholder="Expired at"
                label={<>Expired at</>}
              />
              <ErrorMessage error={fieldState.error?.message} />
            </>
          )}
        />
      </div>

      {type === "BOOKING" && (
        <>
          <div className="col-md-6 mt-4">
            <Controller
              name="promoScope"
              control={control}
              defaultValue="GLOBAL"
              render={({ field, fieldState }) => (
                <div className="d-flex flex-column gap-1">
                  <label>
                    Type de promo <span className="text-danger">*</span>
                  </label>
                  <select {...field} className="form-select">
                    <option value="GLOBAL">Global</option>
                    <option value="EVENT">Event</option>
                    <option value="SPECIALS">Offer</option>
                    <option value="PLACE">Place</option>
                  </select>
                  <ErrorMessage error={fieldState.error?.message} />
                </div>
              )}
            />
          </div>

          {/* RESTRICTION TYPE */}
          {promoScope === "GLOBAL" && (
            <div className="col-md-6 mt-4">
              <Controller
                name="restrictionType"
                control={control}
                defaultValue="NONE"
                render={({ field, fieldState }) => (
                  <>
                    <label>
                      Restreindre à <span className="text-danger">*</span>
                    </label>
                    <select className="form-select" {...field}>
                      {PROMO_RESTRICTION_TYPESV2.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </select>
                    <small className="text-muted">
                      {field.value === ""
                        ? "Le code s'appliquera à tous les événements, offres et lieux"
                        : `Le code s'appliquera uniquement aux ${field.value?.toLowerCase()}s`}
                    </small>
                    <ErrorMessage error={fieldState.error?.message} />
                  </>
                )}
              />
            </div>
          )}

          {/* EVENT */}
          {promoScope === "EVENT" && (
            <div className="col-md-6 mt-4">
              <Controller
                name="event"
                control={control}
                render={({ field, fieldState }) => (
                  <div className="d-flex flex-column gap-1">
                    <label>
                      Restreindre à <span className="text-danger">*</span>
                    </label>
                    <InfiniteScrollSelect
                      url={{ path: "events/ours" }}
                      getOptionLabel={(o: any) => o.name}
                      getOptionValue={(o: any) => o.id}
                      value={field.value}
                      onChange={field.onChange}
                    />

                    <ErrorMessage error={fieldState.error?.message} />
                  </div>
                )}
              />
            </div>
          )}

          {/* OFFER */}
          {promoScope === "SPECIALS" && (
            <div className="col-md-6 mt-4">
              <Controller
                name="offer"
                control={control}
                render={({ field, fieldState }) => (
                  <div className="d-flex flex-column gap-1">
                    <label>
                      Restreindre à <span className="text-danger">*</span>
                    </label>
                    <InfiniteScrollSelect
                      url={{ path: "specials/all" }}
                      getOptionLabel={(o: any) => o.title}
                      getOptionValue={(o: any) => o.id}
                      value={field.value}
                      onChange={field.onChange}
                    />
                    <ErrorMessage error={fieldState.error?.message} />
                  </div>
                )}
              />
            </div>
          )}

          {/* PLACE */}
          {promoScope === "PLACE" && (
            <div className="col-md-6 mt-4">
              <Controller
                name="place"
                control={control}
                render={({ field, fieldState }) => (
                  <div className="d-flex flex-column gap-1">
                    <label>
                      Restreindre à <span className="text-danger">*</span>
                    </label>
                    <InfiniteScrollSelect
                      url={{ path: "places" }}
                      getOptionLabel={(o: any) => o.name}
                      getOptionValue={(o: any) => o.id}
                      value={field.value}
                      onChange={field.onChange}
                    />
                    <ErrorMessage error={fieldState.error?.message} />
                  </div>
                )}
              />
            </div>
          )}
        </>
      )}

      {/* IMAGE */}
      {/* <div className="col-md-6 mt-4">
        <Controller
          name="picture"
          control={control}
          render={({ field, fieldState }) => (
            <div className="d-flex flex-column gap-1">
              <label>
                Image <span className="text-danger">*</span>
              </label>
              <FileUploader
                name="picture"
                onChange={(e: any) => {
                  const file = e.target.files?.[0];
                  field.onChange(file); 
                }}
                file={data?.picture}
              />
              <ErrorMessage error={fieldState.error?.message} />
            </div>
          )}
        />
      </div> */}

      {/* IMAGE */}
      <Controller
        name="picture"
        control={control}
        render={({ field, fieldState }) => (
          <div className="d-flex flex-column gap-1">
            <label>
              Image <span className="text-danger">*</span>
            </label>

            <FileUploaderV2
              name="picture"
              accept="image/png,image/jpeg,image/jpg"
              existingUrl={
                mode === "edit" && !hasNewImage ? data?.picture : undefined
              }
              file={field.value}
              onChange={(file: File | null) => {
                setHasNewImage(true); // 🔥 lock to new file
                setValue("picture", file, {
                  shouldDirty: true,
                  shouldTouch: true,
                });
              }}
            />

            <ErrorMessage error={fieldState.error?.message} />

            {/* <small className="text-muted">
              {field.value instanceof File
                ? `New: ${field.value.name}`
                : data?.picture
                  ? `Current: ${data.picture.split("/").pop()}`
                  : "No image"}
            </small> */}
          </div>
        )}
      />

      {/* ACTIVE */}
      <div>
        <div className="col-md-6 mt-4">
          <Controller
            name="isActive"
            control={control}
            render={({ field, fieldState }) => (
              <>
                <CFormCheck
                  checked={field.value}
                  onChange={(e) => field.onChange(e.target.checked)}
                  label="Active"
                  defaultChecked={data?.isActive || true}
                />
                <ErrorMessage error={fieldState.error?.message} />
              </>
            )}
          />
        </div>

        {/* REUSABLE */}
        <div className="col-md-6 mt-4">
          <Controller
            name="isReusable"
            control={control}
            render={({ field, fieldState }) => (
              <>
                <CFormCheck
                  checked={field.value}
                  onChange={(e) => field.onChange(e.target.checked)}
                  label="Reusable"
                />
                <ErrorMessage error={fieldState.error?.message} />
              </>
            )}
          />
        </div>
      </div>
    </div>
  );
}

export function ErrorMessage({ error }: { error?: string }) {
  if (!error) return null;
  return <div style={{ color: "red", fontSize: "0.85rem" }}>{error}</div>;
}
